import React from 'react'
import { useState } from 'react'
import { CustomizedSnackbar } from '..'
export const CustomizedSnackbarContext = React.createContext()

export function CustomizedSnackbarProvider(props) {
  const { children } = props

  const [ open, setOpen ] = useState(false)
  const [ message, setMessage ] = useState('')
  const [ variant, setVariant ] = useState('')

  const notify = (message, variant) => {
    setOpen(true)
    setMessage(message)
    setVariant(variant)
  }

  const close = () => {
    setOpen(false)
  }

  return (
    <CustomizedSnackbarContext.Provider
      value={{
        open,
        message,
        variant,
        notify,
        close
      }}
    >
      {children}
      <CustomizedSnackbar/>
    </CustomizedSnackbarContext.Provider>
  )
}



// WEBPACK FOOTER //
// ./src/Parts/CustomizedSnackbar/components/CustomizedSnackbarProvider.js